export default __webpack_public_path__ + "static/media/22.6d3e3017.jpg";